module.exports = __webpack_public_path__ + "static/media/apulogo.3ba7ba92.jpg";